/**
 * Embeds an external WebAR / WebGL page (e.g. S3-hosted Unity build).
 * The parent must delegate camera/microphone via `allow` and must not block
 * them in Permissions-Policy (see public/index.html + server headers).
 */
const IFRAME_ALLOW =
  "camera *; microphone *; fullscreen *; autoplay *; clipboard-read *; clipboard-write *; encrypted-media *; accelerometer *; gyroscope *; magnetometer *; geolocation *;";

export default function WebUrlIframe({
  src,
  title = "WebAR",
  id = "vagonFrame",
  className,
}) {
  if (!src) return null;

  return (
    <iframe
      id={id}
      title={title}
      src={src}
      allow={IFRAME_ALLOW}
      allowFullScreen
      scrolling="no"
      className={className}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
        display: "block",
        overflow: "hidden",
      }}
    />
  );
}
